export const GET_MACHINERY_PROPERTY_ASSESSMENT =
  '/machinery/get_machinery_property_assessment';
export const GET_CODED_VALUE_LIST = '/settings/get_coded_value_list';
export const UPDATE_MACHINERY_PROPERTY_ASSESSMENT_TAXABILITY =
  '/machinery/update_machinery_property_assessment_taxability';

export const TAXABILITY_FORM_DATA = {
  taxability: '',
  tax_exempt_code_id: '',
  tax_exempt_reason: '',
};
